import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  boxWrapper: {
    maxWidth: 'calc(50% - 15px)',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: 30,
    marginRight: 30,
    '&:nth-child(2n)': {
      marginRight: 0,
    },
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down(theme.size.sm)]: {
      flexBasis: '100%',
      maxWidth: '100%',
      marginRight: 0,
      '&:nth-last-child(-n+2)': {
        marginBottom: 30,
      },
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  title: {
    margin: 0,
    marginBottom: 10,
    fontSize: 16,
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 210,
    padding: '20px 15px',
    background: '#F2F4F8',
    '& > div': {
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      padding: '15px 10px',
    },
    [theme.breakpoints.down(768)]: {
      minHeight: 'auto',
    },
  },
}));
